import { useState, useEffect } from "react";
import { tripsApi } from "@/lib/api";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface EmailPreviewDialogProps {
  tripId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function EmailPreviewDialog({ tripId, open, onOpenChange }: EmailPreviewDialogProps) {
  const [html, setHtml] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!open) return;
    setHtml(null);
    setError(null);
    setLoading(true);
    tripsApi
      .emailPreview(tripId)
      .then((result) => {
        setHtml(result);
      })
      .catch(() => {
        setError("Failed to load email preview.");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [open, tripId]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Alert email preview</DialogTitle>
        </DialogHeader>
        {loading && (
          <div className="flex items-center justify-center py-12 text-sm text-muted-foreground">
            Loading preview...
          </div>
        )}
        {error && (
          <div className="py-8 text-center text-sm text-destructive">{error}</div>
        )}
        {html && (
          <iframe
            srcDoc={html}
            style={{ width: "100%", height: "70vh", border: 0 }}
            title="Email preview"
            sandbox="allow-same-origin"
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
